import React, { useContext, useState } from "react";
import { PriceContext } from "../../PriceProvider";
import Modal from 'react-bootstrap/Modal';
import './PriceButton.css';

const PriceButton = () => {
    const { loading, currentPrice, lowestPrice, highestPrice, meanPrice, priceCategory } = useContext(PriceContext);
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const handleClick = () => {
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
    };

    if (loading) {
        return (
            <button onClick={handleClick} className="controlpanel-button">Laddar</button>
        )

    }
    return (
        <>
            <button onClick={handleClick} className="controlpanel-button">
                {priceCategory === "LOW" &&
                    <>
                        <i className="bi bi-caret-down text-success controlpanel-button-icon-price" style={{position: 'absolute', top: '-35%'}} />
                        <span className="controlpanel-button-number" style={{position: 'absolute', top: '40%' }}>{currentPrice}&nbsp;kr</span>
                        <span className="controlpanel-button-text" style={{position: 'absolute', bottom: '10%' }}>Elpris</span>
                    </>
                }
                {priceCategory === "MIDDLE" &&
                    <>
                        <i className="bi bi-caret-right text-warning controlpanel-button-icon-price" style={{position: 'absolute', top: '-55%' }} />
                        <span className="controlpanel-button-number" style={{position: 'absolute', top: '40%' }}>{currentPrice}&nbsp;kr</span>
                        <span className="controlpanel-button-text" style={{position: 'absolute', bottom: '10%' }}>Elpris</span>
                    </>
                }
                {priceCategory === "HIGH" &&
                    <>
                        <i className="bi bi-caret-up text-danger controlpanel-button-icon-price" style={{position: 'absolute', top: '-45%' }} />
                        <span className="controlpanel-button-number" style={{position: 'absolute', top: '40%' }}>{currentPrice}&nbsp;kr</span>
                        <span className="controlpanel-button-text" style={{position: 'absolute', bottom: '10%' }}>Elpris</span>
                    </>
                }
            </button>

            <Modal show={modalIsOpen} onHide={closeModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Periodens elpriser</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={`prices d-flex align-items-center`}>
                        <div className={`price-couple text-center`}>
                            <div>
                                <span className="price-title">Just nu</span>
                            </div>
                            <div>
                                <span className="price me-1 text-secondary">{currentPrice}</span>
                            </div>
                            <div>
                                <span className="price-unit">kr/kWh</span>
                            </div>
                        </div>
                        <div className={`price-couple text-center`}>
                            <div>
                                <span className="price-title">Lägsta</span>
                            </div>
                            <div>
                                <span className="price me-1 text-success">{lowestPrice}</span>
                            </div>
                            <div>
                                <span className="price-unit">kr/kWh</span>
                            </div>
                        </div>
                        <div className={`price-couple text-center`}>
                            <div>
                                <span className="price-title">Högsta</span>
                            </div>
                            <div>
                                <span className="price me-1 text-danger">{highestPrice}</span>
                            </div>
                            <div>
                                <span className="price-unit">kr/kWh</span>
                            </div>
                        </div>
                        <div className={`price-couple text-center`}>
                            <div>
                                <span className="price-title">Snitt</span>
                            </div>
                            <div>
                                <span className="price me-1 text-warning">{meanPrice}</span>
                            </div>
                            <div>
                                <span className="price-unit">kr/kWh</span>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default PriceButton;